import { useQuery } from 'react-query'
import { fetchSupabaseUser } from '../../api/fetchSupabaseUser'

export const useSupabaseUser = () => {
  return useQuery(['supabase-user'], () => fetchSupabaseUser())
}
